import { z } from "zod/v4";

import { createEndpointBase } from "./core";

const base = "mail";
const mail = createEndpointBase(base);

export const mailEndpoints = {
  mailVerify: mail({
    method: "POST",
    path: "verify",
    request: z.any(),
    response: z.any(),
    description: "Verifies the mail configuration.",
  }),
  mailTestEmail: mail({
    method: "POST",
    path: "test-email",
    request: z.object({ emailAddress: z.string() }),
    response: z.any(),
    description: "Sends a test e-mail to the specified address.",
  }),
} as const;
